import * as React from "react";

import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";

import { WizardRegionHotwireModel } from "../typings";
import { MobileHeading } from "./MobileHeading";

export interface MobileContentNoImageProps {
  model: WizardRegionHotwireModel;
  wizard?: React.ReactElement;
}

export const MobileContentNoImage = ({ model, wizard }: MobileContentNoImageProps) => (
  <UitkSpacing padding={{ blockstart: "six", inline: "three" }}>
    <UitkLayoutFlex direction="column">
      <UitkLayoutFlexItem>
        <UitkSpacing margin={{ blockend: "three" }}>
          <div>
            <MobileHeading title={model.title} innerTitle={model.innerTitle} />
          </div>
        </UitkSpacing>
      </UitkLayoutFlexItem>
      <UitkLayoutFlexItem>{wizard}</UitkLayoutFlexItem>
    </UitkLayoutFlex>
  </UitkSpacing>
);
